import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
import "./AssetCustomer.css";
import { useNavigate, useLocation } from "react-router-dom";
import TicketSidebar from "../components/TicketSidebar";
import { useCustomer } from "../contexts/CustomerContext";

axios.defaults.withCredentials = true;

const NewTicket = () => {
  const [helpTopic, setHelpTopic] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [severityLevel, setSeverityLevel] = useState("");
  const [sla, setSla] = useState("");
  const { user } = useCustomer();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    issueSummary: false,
    issueDetails: false,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const selectedAsset = location.state?.selectedAsset || null;
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    position: "",
    phoneNumber: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    password: "",
    confirmPassword: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    locationAddress: "",
    sla: "Platinum (7x24x4)",
    serialNumber: "",
    productName: "",
    customerName: "",
    customer_asset_id: "",
  });

  const [ticketPopup, setTicketPopup] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
    redirectTo: "",
  });

  const showTicketPopup = ({
    type = "info",
    title = "",
    message = "",
    redirectTo = "",
  }) => {
    setTicketPopup({
      show: true,
      type,
      title,
      message,
      redirectTo,
    });
  };

  const closeTicketPopup = () => {
    const redirectTo = ticketPopup.redirectTo;

    setTicketPopup({
      show: false,
      type: "",
      title: "",
      message: "",
      redirectTo: "",
    });

    if (redirectTo) {
      navigate(redirectTo);
    }
  };

  useEffect(() => {
    if (!selectedAsset) {
      showTicketPopup({
        type: "error",
        title: "ไม่พบ Serial Number",
        message: "กรุณาเลือก Serial Number จากหน้ารายการก่อน",
        redirectTo: "/customer/tickets",
      });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      serialNumber: selectedAsset.prd_serial || "",
      productName: selectedAsset.prd_label || "",
      customerName: selectedAsset.cus_name || "",
      customer_asset_id: selectedAsset.id || "",
    }));
  }, [selectedAsset, navigate]);

  useEffect(() => {
    const fetchAssetTicketInfo = async () => {
      if (!selectedAsset?.id) {
        showTicketPopup({
          type: "error",
          title: "ไม่พบ Serial Number",
          message: "กรุณาเลือก Serial Number จากหน้ารายการก่อน",
          redirectTo: "/customer/tickets",
        });
        return;
      }

      try {
        const res = await axios.get(
          `/customer-assets/${selectedAsset.id}/ticket-info`,
          { withCredentials: true },
        );

        const asset = res.data || {};

        setFormData((prev) => ({
          ...prev,
          email: asset.customer_email || "",
          fullName: asset.customer_name || "",
          phoneNumber: asset.customer_phone || "",
          serialNumber: asset.serial || "",
          productName: asset.product || "",
          customerName:
            asset.company_name || asset.customer_name || asset.customer || "",
          customer_asset_id: asset.id || "",
          address: asset.location || "",
          locationAddress: asset.location || "",
        }));

        setSla(asset.current_sla || "");
      } catch (err) {
        showTicketPopup({
          type: "error",
          title: "ไม่สามารถดึงข้อมูลได้",
          message: "ไม่สามารถดึงข้อมูล Asset ได้",
          redirectTo: "/customer/assets-list",
        });
      }
    };

    fetchAssetTicketInfo();
  }, [selectedAsset, navigate]);

  const handleHelpTopicChange = (e) => {
    const selectedHelpTopic = e.target.value;
    setHelpTopic(selectedHelpTopic);
    setSeverityLevel(
      selectedHelpTopic === "Feedback and General Questions"
        ? "low"
        : selectedHelpTopic === "Report Hardware /Software System Down"
          ? "high"
          : "medium",
    );
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
    if (id === "issueSummary" || id === "issueDetails") {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [id]: false,
      }));
    }
  };

  const handleFileChange2 = (event) => {
    const files = Array.from(event.target.files || []);

    if (files.length + selectedFiles.length > 7) {
      showTicketPopup({
        type: "error",
        title: "อัปโหลดไฟล์เกินจำนวน",
        message: "คุณสามารถอัปโหลดไฟล์ได้ไม่เกิน 7 ไฟล์เท่านั้น",
      });

      event.target.value = "";
      return;
    }

    setSelectedFiles((prev) => [...prev, ...files]);

    event.target.value = "";
  };

  const handleRemoveFile = (indexToRemove) => {
    setSelectedFiles((prev) =>
      prev.filter((_, index) => index !== indexToRemove),
    );

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleClearFiles = () => {
    setSelectedFiles([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const submitForm = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formData.email)) {
      showTicketPopup({
        type: "error",
        title: "อีเมลไม่ถูกต้อง",
        message: "Please enter a valid email.",
      });

      setIsSubmitting(false);
      return;
    }

    if (!phoneRegex.test(formData.phoneNumber)) {
      showTicketPopup({
        type: "error",
        title: "เบอร์โทรศัพท์ไม่ถูกต้อง",
        message: "Please enter a 10-digit phone number.",
      });

      setIsSubmitting(false);
      return;
    }

    if (!formData.address) {
      showTicketPopup({
        type: "error",
        title: "ไม่พบ Location",
        message: "Asset นี้ยังไม่มี Location กรุณาติดต่อผู้ดูแลระบบ",
      });

      setIsSubmitting(false);
      return;
    }

    if (!sla) {
      showTicketPopup({
        type: "error",
        title: "ไม่พบ SLA",
        message: "Asset นี้ยังไม่มี SLA กรุณาติดต่อผู้ดูแลระบบ",
      });

      setIsSubmitting(false);
      return;
    }

    const missingFields = [];

    const errors = {
      issueSummary: false,
      issueDetails: false,
    };

    if (!formData.serialNumber) missingFields.push("Serial Number");
    if (!helpTopic) missingFields.push("Help Topic");

    if (!formData.issueSummary.trim()) {
      missingFields.push("Issue Summary");
      errors.issueSummary = true;
    }

    if (!severityLevel) missingFields.push("Severity Level");
    if (!sla) missingFields.push("SLA");

    if (!formData.issueDetails.trim()) {
      missingFields.push("Details");
      errors.issueDetails = true;
    }

    if (missingFields.length > 0) {
      setValidationErrors(errors);

      showTicketPopup({
        type: "error",
        title: "กรุณากรอกข้อมูลให้ครบ",
        message: `กรุณากรอก: ${missingFields.join(", ")}`,
      });

      setIsSubmitting(false);
      return;
    }

    setValidationErrors({
      issueSummary: false,
      issueDetails: false,
    });

    const formDataObj = new FormData();

    formDataObj.append("id", user?.customerId);
    formDataObj.append("location", formData.locationAddress);
    formDataObj.append("helpTopic", helpTopic);
    formDataObj.append("issueSummary", formData.issueSummary);
    formDataObj.append("severityLevel", severityLevel);
    formDataObj.append("sla", sla);
    formDataObj.append("issueDetails", formData.issueDetails);
    formDataObj.append("serialNumber", formData.serialNumber);
    formDataObj.append("productName", formData.productName);
    formDataObj.append("customerName", formData.customerName);
    formDataObj.append("customer_asset_id", formData.customer_asset_id);

    selectedFiles.forEach((file) => {
      formDataObj.append("attachedFiles", file);
    });

    try {
      const response = await fetch("/ticketcustomer", {
        method: "POST",
        credentials: "include",
        body: formDataObj,
      });

      if (!response.ok) {
        const contentType = response.headers.get("content-type");

        const errorText =
          contentType && contentType.includes("application/json")
            ? (await response.json()).message
            : await response.text();

        showTicketPopup({
          type: "error",
          title: "สร้าง Ticket ไม่สำเร็จ",
          message: errorText || "เกิดข้อผิดพลาดในการสร้าง Ticket",
        });

        return;
      }

      const responseData = await response.json();

      resetForm();

      const fileInput = document.getElementById("fileupload");
      if (fileInput) fileInput.value = "";

      showTicketPopup({
        type: "success",
        title: "สร้าง Ticket สำเร็จ",
        message: `Ticket created successfully! Your ticket number is ${responseData.ticketNumber}`,
        redirectTo: "/customer/tickets",
      });
    } catch (error) {
      showTicketPopup({
        type: "error",
        title: "เกิดข้อผิดพลาด",
        message: `An error occurred: ${error.message}`,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData((prev) => ({
      ...prev,
      issueSummary: "",
      issueDetails: "",
      severityLevel: "",
      sla: "Silver (5x8xNBD)",
      fileupload: [],
      files: [],
    }));
    setHelpTopic("");
    setSelectedFiles([]);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSeverityLevelsChange = (e) => {
    setSeverityLevel(e.target.value);
  };

  return (
    <div className="ticket-container">
      <TicketSidebar active="/customer/assets" />

      <div className="ticket-main-content">
        <div className="ticket-form-container">
          <div className="ticket-action-row">
            <button className="back-btn" onClick={() => navigate(-1)}>
              Back
            </button>

            <div className="form-actions">
              <button
                onClick={submitForm}
                className="submit-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Processing..." : "Create Ticket"}
              </button>
            </div>
          </div>
          <h2 className="title-open-new-ticket">Open a New Ticket</h2>

          <div className="asset-readonly-box">
            <div className="asset-readonly-grid">
              <div className="form-group">
                <label>Serial Number:</label>
                <input type="text" value={formData.serialNumber} readOnly />
              </div>

              <div className="form-group">
                <label>Product:</label>
                <input type="text" value={formData.productName} readOnly />
              </div>

              <div className="form-group">
                <label>Company Name:</label>
                <input type="text" value={formData.customerName} readOnly />
              </div>
            </div>
          </div>
          <p>Please fill in the form below to open a new ticket.</p>

          <div className="form-group">
            <label>Email :</label>
            <input type="email" id="email" value={formData.email} readOnly />
          </div>

          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              id="fullName"
              value={formData.fullName}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              value={formData.phoneNumber}
              readOnly
            />
          </div>

          <div className="form-group">
            <label>Address:</label>
            <textarea
              value={formData.locationAddress || "-"}
              readOnly
              className="w-full p-2 border rounded mb-2"
            />
          </div>

          <div className="form-group">
            <label>SLA:</label>
            <input type="text" value={sla || "-"} readOnly />
          </div>

          <div className="form-group">
            <label className="ticket-field-label">
              Help Topic
              <span className="ticket-required-star">*</span>
            </label>
            <select
              id="help-topic"
              value={helpTopic}
              onChange={handleHelpTopicChange}
              className="help-topic-select"
            >
              <option value="">Select a Help Topic</option>
              <option value="Feedback and General Questions">
                Feedback and General Questions
              </option>
              <option value="Report Hardware / Software Performamce Issue">
                Report Hardware / Software Performance Issue
              </option>
              <option value="Report Hardware /Software System Down">
                Report Hardware / Software System Down
              </option>
            </select>
          </div>

          <div className="form-group">
            <label>Severity Levels:</label>
            <select
              id="Severity-Levels"
              value={severityLevel}
              onChange={handleSeverityLevelsChange}
              className="help-topic-select no-arrow"
              disabled
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>

          {helpTopic && (
            <>
              <div className="form-group">
                <label className="ticket-field-label">
                  Issue Summary
                  <span className="ticket-required-star">*</span>
                </label>
                <input
                  type="text"
                  id="issueSummary"
                  name="issueSummary"
                  value={formData.issueSummary}
                  onChange={handleInputChange}
                  placeholder="Brief summary of your issue"
                  style={
                    validationErrors.issueSummary
                      ? { border: "1px solid red" }
                      : {}
                  }
                />
              </div>

              <div className="form-group">
                <label className="ticket-field-label">
                  Details
                  <span className="ticket-required-star">*</span>
                </label>
                <textarea
                  id="issueDetails"
                  name="issueDetails"
                  value={formData.issueDetails}
                  onChange={handleInputChange}
                  placeholder="Provide details about the issue"
                  style={
                    validationErrors.issueDetails
                      ? { border: "1px solid red" }
                      : {}
                  }
                />
              </div>

              <div className="form-group">
                <label>Attach Files (ไม่บังคับ)</label>

                <input
                  ref={fileInputRef}
                  type="file"
                  id="fileupload"
                  multiple
                  onChange={handleFileChange2}
                />

                {selectedFiles.length > 0 ? (
                  <>
                    <ul className="selected-file-list">
                      {selectedFiles.map((file, index) => (
                        <li key={`${file.name}-${file.size}-${index}`}>
                          <span>{file.name}</span>

                          <button
                            type="button"
                            className="remove-file-button"
                            onClick={() => handleRemoveFile(index)}
                          >
                            ลบ
                          </button>
                        </li>
                      ))}
                    </ul>

                    <button
                      type="button"
                      className="clear-files-button"
                      onClick={handleClearFiles}
                    >
                      ลบไฟล์ทั้งหมด
                    </button>
                  </>
                ) : (
                  <p>ยังไม่ได้เลือกไฟล์</p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {ticketPopup.show && (
        <div className="customer-ticket-popup-overlay">
          <div className="customer-ticket-popup-modal">
            <h3>{ticketPopup.title}</h3>

            <p>{ticketPopup.message}</p>

            <div className="customer-ticket-popup-actions">
              <button
                type="button"
                className={`customer-ticket-popup-btn ${
                  ticketPopup.type === "success" ? "success" : "error"
                }`}
                onClick={closeTicketPopup}
              >
                ตกลง
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NewTicket;
